import { getAPIPath, requestGooseAPI } from '../shared/request'
import { APIPaymentSettingClientDtoResponse } from '../types/api'
import { CLIENT_PAYMENT_SETTINGS_PATH } from '../types/constants'

export const ClientPaymentSettingService = {
  list: async (
    locationName: string,
    options: { locationBookingSurcharge: string }
  ): Promise<APIPaymentSettingClientDtoResponse> => {
    const res = await requestGooseAPI<APIPaymentSettingClientDtoResponse>({
      url: getAPIPath(CLIENT_PAYMENT_SETTINGS_PATH, { locationId: locationName }),
      method: 'GET',
      params: {
        ...options,
        includes: ['restrictionRelations.restriction.periods'],
      },
    })
    return {
      results: res.results ?? [],
      nextToken: res.nextToken ?? null,
    }
  },
}
